export const scanDateTimeFormat = 'YYYYMMDDHHmmss';
